import { DEBUG } from "../assets";
import type { CourseId, Mode } from "../config/types";

const params = DEBUG ? new URLSearchParams(location.search) : new URLSearchParams();

const num = (name: string) => (params.has(name) ? Number(params.get(name)) : undefined);

export const debugParams = {
    scene: params.get("scene") ?? undefined,
    seed: num("seed"),
    course: num("course") as CourseId | undefined,
    mode: (params.get("mode") ?? undefined) as Mode | undefined,
    autopilot: params.get("autopilot") ?? undefined,
    timeScale: num("timescale"),
    startM: num("start"),
};
